const index = `<!DOCTYPE html>
<html lang='en'>

<head>
  <meta charset='UTF-8'>
  <title>CSS Grid</title>
  <link href="https://fonts.googleapis.com/css?family=Lato" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css?family=PT+Serif" rel="stylesheet">

  <style>
    body {
      font-family: 'Lato', sans-serif;
      background-color: #ffffff;
    }
    p,
    li {
      font-family: 'PT Serif', serif;
    }
    .container {
        display: flex;
        justify-content: center;
    }
    .content-wrapper {
        width: 660px
    }
    .style-details {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        margin-top: 75px;
        margin-bottom: 75px;
    }

    .style-details-text {
        text-align: right;
    }

    .style-details-text div {
        color: #808080;
        font-weight: normal;
    }
    .style-details-text h3 {
        margin-top: 40px;
        margin-bottom: 10px;
    }


    .style-details-logo img {
        width: 100%;
    }
    .dos_donts_wrapper {
        margin-top: 75px;
        margin-top: 75px;
        display: grid;
        grid-template-columns: 2fr 2fr 1fr;
        gap: 30px;
    }

    .dont_image_box {
        text-align: center;
        margin-bottom: 20px;
    }

    .dont_image_box div {
        font-size: 14px;
        color: #999999
    }


    .dont_image_box img {
        width: 50%;
    }
    .dos_donts_heading {
        font-weight: 900;
        margin-bottom: 20px;
        margin-left: 40px;
    }
    .blue_text {
        color: #0079ff;
    }
    .red_text {
        color: #dc0004;
    }

    .dos_donts_list li {
        margin-top: 30px;
        margin-bottom: 30px;
        font-size: 16px;
    }
    .alternate_options_wrapper {
        margin-top: 75px;
        margin-bottom: 75px;
    }
    .alternate_options_wrapper h3 {
        color: #999999;
        font-size: 18px;
        font-weight: 900;        
    }
    .alternate_options_wrapper li {
        margin-top: 30px;
        margin-bottom: 30px;
        font-size: 19px;       
    }
    .alternate_options_images {
        margin-top: 80px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        justify-items: center;
        gap: 100px 40px;
    }

    .image_logos {
        width: 60%;
    }
    .text_logos {
        width: 90%;
    }

    .additional_branding_details {
        margin-top: 75px;
        margin-bottom: 75px;
    }
    .additional_branding_details a {
        color: #4fb8e8;
        font-size: 19px;
    }

    .additional_branding_details p {
        margin-bottom: 42px;        
    }

    @media (max-width: 48em) {
        .style-details {
            grid-template-columns: 1fr;
            gap: 50px;
        }
        .style-details-text {
            text-align: center;
        }
        .dos_donts_wrapper {
            grid-template-columns: 1fr;
        }
    }

    

  </style>
</head>

<body>
    <div class="container">

        <div class="content-wrapper">

            <h2> Branding Guidelines</h2>
           
            <p>Welcome to the DailySmarty branding guidelines! We’re happy that you see the worth of our product and understand the value in promoting it correctly.</p>

            <p>The folowing guides have been provided to assist you in maintaining the integrity and intedended useage of our logo and branding in your marketing materials. Keeping with these guidelines will reinforce both your and our professionalism and legitimacy in the eyes of the audience.</p>

            <p>Thank you again for your interest and relationship with DailySmarty. Please see the guidelines outlined below (logo assets can be downloaded below):</p>
            <div class="style-details">
                <div class="style-details-text">                
                    <h3>Primary Logo</h3>
                    <div>White Space = 1/4 logo width</div>
                    <div>White logo on primary blue</div>
    
                    <h3>Primary Color</h3>
                    <div>#0079FF</div>
                    <div>RGB 0, 121, 255</div>
    
                    <h3>Name</h3>
                    <div>Capitalize “D” and “S”</div>
                    <div>No space between the words</div>
                </div>
                <div class="style-details-logo">
                    <img src="./images/logo-with-margin.png" alt="logo-with-margin">
                </div>
            </div>
            <div class="dos_donts_wrapper">
                <div class="dos_donts_list">
                    <div class="dos_donts_heading blue_text">
                        Logo Do's
                    </div>
                    <ul>
                        <li>Provide adequate white space surrounding the logo.</li>
                        <li>Icon must always be white</li>
                        <li>Keep a large size so the icon doesn’t get obscured.</li>
                        <li>Place logo on white or light background colors</li>
                    </ul>
                </div>
                <div class="dos_donts_list">
                    <div class="dos_donts_heading red_text">
                        Logo Dont's
                    </div>
                    <ul>
                        <li>Strech or scale the logo non-uniformely</li>
                        <li>Crop or partially cover the logo with other objects</li>
                        <li>Alter the logo or wordmark color to anything other than our primary color</li>
                    </ul>                    
                </div>
                <div class="donts_images">
                    <div class="dont_image_box">
                        <img src="./images/dont_stretch.png" alt="">
                        <div>Stretch</div>
                    </div>
                    <div class="dont_image_box">
                        <img src="./images/dont_crop.png" alt="">
                        <div>Crop</div>
                    </div>
                    <div class="dont_image_box">
                        <img src="./images/dont_color.png" alt="">
                        <div>Color</div>
                    </div>
                </div>
            </div>
            <div class="alternate_options_wrapper">
                <h3>Alternate Options</h3>
                <ul>
                    <li>The circular badge can be used separately from the wordmark.</li>
                    <li>The icon may be extracted from the logo and applied separately - but it must remain white and have a background of our primary blue color.</li>
                    <li>The wordmark may be used separately from the circular badge.</li>
                    <li>Logo Do’s and Do Not’s above still apply.</li>
                </ul>

                <div class="alternate_options_images">
                    <img class="image_logos" src="./images/ds_circle_logo.png" alt="">
                    <img class="image_logos" src="./images/ds_square_logo.png" alt="">
                    <img class="text_logos" src="./images/ds_icon_text_logo.png" alt="">
                    <img class="text_logos" src="./images/ds_text_logo.png" alt="">
                </div>
            </div>
            <div class="additional_branding_details">
                <h3>Asset Download</h3>
                <p>
                    <a href="#"> Download .zip file</a>
                </p>
                <h3>Usage</h3>
                <p>
                    Please remember to adhere to the above guidlines when referencing and using our logos. If you are unsure of the correct protocol for a particular usecase, feel free to ask us at the following email: support@dailysmarty.com.
                </p>
            </div>
        </div>

    </div>
</body>

</html>`
export default index